module.exports = __webpack_public_path__ + "img/fondo111.6edc66c6.jpg";